import styled from 'styled-components';

interface IContainerProps {
  isActive?: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0.5rem 1rem;
`;

export const Content = styled.div<IContainerProps>`
  display: flex;
  justify-content: center;
  width: 100%;
  position: relative; // Para posicionar .preferential corretamente

  .preferential {
    background-color: ${({ theme }) => theme.colors.primary};
    width: 2rem;
    height: 3rem;
    position: absolute;
    top: -17px;
    left: -12px;
    transform: rotate(43deg);
  }

  button {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    background-color: ${({ theme, isActive }) =>
      isActive ? '#D6D6D6' : theme.colors.background_white};
    border-radius: 1rem;
    padding: 1rem;
    width: 100%;
    overflow: hidden;
    box-shadow: 1px 2px 6px rgb(0 0 0 / 20%);
    text-align: left;
    gap: 0.75rem;
  }

  .content {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    .holder {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }
  }

  .header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    width: 100%;

    svg {
      width: 1.3rem;
    }

    h1 {
      font-size: 1.2rem;
      color: ${({ theme }) => theme.colors.primary};
      font-weight: normal;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      flex: 1;
    }
  }

  p {
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.text};
    display: flex;
    align-items: center;
    gap: 0.4rem;
    width: 100%;

    span {
      color: ${({ theme }) => theme.colors.primary};
      font-weight: 300;
      letter-spacing: 1px;
      text-transform: uppercase;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      flex: 1;
    }
  }

  @media (max-width: 390px) {
    .header {
      flex-direction: row !important;
    }
  }
`;
